<template>
  <div class="shoplist">
    <v-app-bar
      app
    >
      <v-btn
        icon
        color="blue-grey darken-4"
        onclick="window.history.go(-1)"
      >
        <v-icon>mdi-less-than</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div class="d-flex align-center mr-7">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://shop.cheerlife.io/img/logo_a.png"
          transition="scale-transition"
          width="22"
        />
        <v-toolbar-title>成立訂單</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-card class="mx-auto">
      <v-card-text>運送方式：<font color="error">直接購買</font></v-card-text>
    </v-card>
    <br />
    <v-card class="mb-3">
      <v-list-item>
        <v-list-item-content>訂購人資料</v-list-item-content>
        <v-list-item-action>
          <v-dialog
            v-model="orderinfo[0].order_dialog"
            persistent
            width="500"
          >
            <template v-slot:activator="{ on }">
              <v-btn text color="error" v-on="on" v-show="is_order_buy">
                編輯
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">新增訂購人資訊</v-card-title>
              <v-card-text>
                <v-text-field
                  label="姓名"
                  placeholder="請填真實姓名"
                  v-model="orderinfo[0].order_edit_name"
                ></v-text-field>
                <v-text-field
                  v-model="orderinfo[0].order_edit_mail"
                  label="信箱"
                ></v-text-field>
                <v-text-field
                  v-model="orderinfo[0].order_edit_phone"
                  label="電話"
                ></v-text-field>
                <div class="mb-5" v-show="isnt_linechecked">
                  <p>※ 訂單成立後您將成為CheerLife會員，手機號碼則會成為您的會員帳號。</p>
                  <div class="text-center mb-5">
                    <v-btn color="error" @click="SendSMSCode()">取得此手機號碼的驗證碼</v-btn>
                  </div>
                  <v-text-field
                    label="輸入簡訊中的驗證碼"
                    outlined
                    v-model="inputsms"
                  ></v-text-field>
                  <div class="text-center mb-3" style="margin-top: -20px;">
                    <v-btn color="error" @click="CheckSMSCode()">確認送出</v-btn>
                  </div>
                </div>
                <div v-show="is_linechecked">
                  <v-input style="margin-bottom: -30px;">訂購人地址</v-input>
                  <div v-show="not_first_address">
                    <v-radio-group v-model="orderinfo[0].orderradioGroup" @change="onOrderChange($event)">
                      <v-radio
                        label="依公司地址"
                        value="2"
                      ></v-radio>
                      <v-radio
                        label="其他地址"
                        value="1"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                  <div v-show="order_company_show">
                    <v-text-field
                      v-model="orderinfo[0].order_edit_company_address"
                      label="公司地址"
                    ></v-text-field>
                    <v-text-field
                      v-model="orderinfo[0].order_edit_company_name"
                      label="公司名"
                    ></v-text-field>
                  </div>
                  <div v-show="order_home_show">
                    <v-row align="center">
                      <v-col class="d-flex" cols="6">
                        <div class="select_sty">
                          <select v-model="order_edit_home_area_lists" @change="onOrderAreaChange">
                           <option value="">城市/地區</option>
                           <option v-for="product in area_lists" :key="product">
                             {{ product }}
                           </option>
                         </select>
                        </div>
                      </v-col>
                      <v-col class="d-flex" cols="6">
                        <div class="select_sty">
                          <select v-model="order_edit_home_area_detail">
                            <option value="">區/縣</option>
                            <option v-for="detail in area_detail[order_edit_home_area_lists]" :key="detail">{{ detail }}</option>
                          </select>
                        </div>
                      </v-col>
                    </v-row>
                    <p>請務必填寫正確的配送及聯絡資訊，確認後不可修改。</p>
                    <v-text-field
                      v-model="orderinfo[0].order_edit_home_address"
                      label="訂購人地址"
                    ></v-text-field>
                  </div>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="orderinfo[0].order_dialog = false"
                >
                  取消
                </v-btn>
                <v-btn
                  color="primary"
                  @click="CheckOrderAddress"
                >
                  確認
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-item-action>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <div class="text-center mt-3">
        <v-btn outlined color="error" @click="orderinfo[0].order_dialog = true" v-show="isnt_order_buy">
          <v-icon left>mdi-pencil</v-icon> 增加訂購人資訊
        </v-btn>
      </div>
      <div v-show="is_order_buy">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>姓名：{{ orderinfo[0].order_name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>電話：{{ orderinfo[0].order_phone }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>信箱：{{ orderinfo[0].order_mail }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>地址：{{ orderinfo[0].order_mix_address }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-show="false">
          <v-list-item-content>
            <v-list-item-title>
              {{ order_home_area_lists }} <br />
              {{ order_home_area_detail }} <br />
              {{ orderinfo[0].order_home_address }} <br />
              {{ orderinfo[0].order_company_address }} <br />
              {{ orderinfo[0].order_company_name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-card>
    <v-card class="mb-3">
      <v-list-item>
        <v-list-item-content>
          收貨人資料
        </v-list-item-content>
        <v-list-item-action>
          <v-dialog
            v-model="receiptinfo[0].receipt_dialog"
            persistent
            width="500"
          >
            <template v-slot:activator="{ on }">
              <v-btn text color="error" v-on="on" v-show="is_receipt_buy">
                編輯
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">新增收貨人資訊</v-card-title>
              <v-card-text>
                <v-text-field
                  label="姓名"
                  placeholder="請填真實姓名"
                  v-model="receiptinfo[0].receipt_edit_name"
                ></v-text-field>
                <v-text-field
                  v-model="receiptinfo[0].receipt_edit_mail"
                  label="信箱"
                ></v-text-field>
                <v-text-field
                  v-model="receiptinfo[0].receipt_edit_phone"
                  label="電話"
                ></v-text-field>
                <v-input style="margin-bottom: -30px;">收貨人地址</v-input>
                <div v-show="not_first_address">
                  <v-radio-group v-model="receiptinfo[0].receiptradioGroup" @change="onReceiptChange($event)">
                    <v-radio
                      label="依公司地址"
                      value="2"
                    ></v-radio>
                    <v-radio
                      label="其他地址"
                      value="1"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div v-show="receipt_company_show">
                  <v-text-field
                    v-model="receiptinfo[0].receipt_edit_company_address"
                    label="公司地址"
                  ></v-text-field>
                  <v-text-field
                    v-model="receiptinfo[0].receipt_edit_company_name"
                    label="公司名"
                  ></v-text-field>
                </div>
                <div v-show="receipt_home_show">
                  <v-row align="center">
                    <v-col class="d-flex" cols="6">
                      <div class="select_sty">
                        <select v-model="receipt_edit_home_area_lists" @change="onRecriptAreaChange">
                          <option value="">城市/地區</option>
                          <option v-for="product in area_lists" :key="product">
                            {{ product }}
                          </option>
                        </select>
                      </div>
                    </v-col>
                    <v-col class="d-flex" cols="6">
                      <div class="select_sty">
                        <select v-model="receipt_edit_home_area_detail">
                          <option value="">區/縣</option>
                          <option v-for="detail in area_detail[receipt_edit_home_area_lists]" :key="detail">{{ detail }}</option>
                        </select>
                      </div>
                    </v-col>
                  </v-row>
                  <p>請務必填寫正確的配送及聯絡資訊，確認後不可修改。</p>
                  <v-text-field
                    v-model="receiptinfo[0].receipt_edit_home_address"
                    label="訂購人地址"
                  ></v-text-field>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="receiptinfo[0].receipt_dialog = false"
                >
                  取消
                </v-btn>
                <v-btn
                  color="primary"
                  @click="CheckReceiptAddress"
                >
                  確認
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-checkbox
            label="同訂購人資料"
            v-model="order_checkbox"
            @change="SameOrderData"
          ></v-checkbox>
        </v-list-item-action>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <div class="text-center mt-3">
        <v-btn outlined color="error" @click="receiptinfo[0].receipt_dialog = true" v-show="isnt_receipt_buy">
          <v-icon left>mdi-pencil</v-icon> 增加收貨人資訊
        </v-btn>
      </div>
      <div v-show="is_receipt_buy">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>姓名：{{ receiptinfo[0].receipt_name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>電話：{{ receiptinfo[0].receipt_phone }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>信箱：{{ receiptinfo[0].receipt_mail }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>地址：{{ receiptinfo[0].receipt_mix_address }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-show="false">
          <v-list-item-content>
            <v-list-item-title>
              {{ receipt_home_area_lists }} <br />
              {{ receipt_home_area_detail }} <br />
              {{ receiptinfo[0].receipt_home_address }} <br />
              {{ receiptinfo[0].receipt_company_address }} <br />
              {{ receiptinfo[0].receipt_company_name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-card>
    <v-card class="mb-3">
      <v-list-item>
        <v-list-item-content>
          付款方式
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-radio-group v-model="PayradioGroup">
            <v-radio
              label="信用卡"
              value="1"
            ></v-radio>
          </v-radio-group>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <v-card class="mb-3">
      <v-list-item>
        <v-list-item-content>
          商品清單
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <div class="d-flex flex-no-wrap justify-space-between">
        <v-avatar
          class="ma-3"
          size="100"
          tile
        >
          <v-img :src="shop_info.image_url"></v-img>
        </v-avatar>
        <div>
          <v-card-text>
            <p class="headline text--primary">
              {{ shop_info.name }}
            </p>
            <div class="text--primary">
              {{ shop_info.spec }}
            </div>
          </v-card-text>
        </div>
      </div>
    </v-card>
    <v-card class="mb-3">
      <v-list-item>
        <v-list-item-content>
          組數：1
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <v-list-item>
        <v-list-item-content>
          商品總價：{{ shop_info.special_price }}
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <v-list-item>
        <v-list-item-content>
          運費：{{ shop_info.shipping_fee }}
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <v-list-item>
        <v-list-item-content>
          服務費：0
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <v-list-item>
        <v-list-item-content>
          總金額：{{ shop_info_total_price }}
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mx-4"></v-divider>
      <v-list-item>
        <v-list-item-content>
          如需更改品項請於此備註(例:辣味*1)
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-textarea
            filled
            name="shop_hint"
            label="備註"
            :value="remark"
          ></v-textarea>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <div class="text-center mb-5">
      <v-btn rounded large color="error" @click="CheckOrderData()" :disabled="cantsendclick">確定送出訂單</v-btn>
    </div>
    <form
      action="https://shopbkd.cheerlife.io/12team/v1/grouporder/pay_limit"
      method="POST"
      id="bluemoneyForm"
    >
      <input id="order_uuid" type="hidden" name="order_uuid" :value="sendbluemoney[0].order_uuid" >
      <input id="order_id" type="hidden" name="order_id" :value="sendbluemoney[0].order_id" >
      <input id="price" type="hidden" name="price" :value="sendbluemoney[0].price" >
      <input id="email" type="hidden" name="email" :value="sendbluemoney[0].email" >
      <input id="production" type="hidden" name="production" :value="sendbluemoney[0].production" >
    </form>
    <CheerLifeFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue';
import CheerLifeFooter from '@/components/CheerLifeFooter.vue';

export default {
  name: 'shoplist',
  components: {
    CheerLifeFooter,
  },
  computed: {

  },
  data: () => ({
    access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
    user_line_id: '',
    inputsms: '',
    product_id: '',
    group_uuid: '',
    shipping_fee: 0,
    url_title: '',
    // line ckeck
    is_line_register: "not_registered",
    isnt_linechecked: true,
    is_linechecked: false,
    // is first buy
    is_order_buy: false,
    isnt_order_buy: true,
    is_receipt_buy: false,
    isnt_receipt_buy: true,
    not_first_address: true,
    // checkbox same as order
    pre_rec_address_type: '',
    // order user
    orderinfo: [
      {
        order_dialog: false,
        order_name: '',
        order_mail: '',
        order_phone: '',
        // edit
        order_edit_name: '',
        order_edit_mail: '',
        order_edit_phone: '',
        orderradioGroup: '2',
        order_edit_home_address: '',
        order_edit_company_address: '',
        order_edit_company_name: '',
        // type 2
        order_company_address: '',
        order_company_name: '',
        // type 1
        order_home_address: '',
        // mix address
        order_mix_address: '',
      },
    ],
    order_company_show: true,
    order_home_show: false,
    order_edit_home_area_lists: '',
    order_edit_home_area_detail: '',
    order_home_area_lists: '',
    order_home_area_detail: '',
    order_checkbox: false,
    // receipt user
    receiptinfo: [
      {
        receipt_dialog: false,
        receipt_name: '',
        receipt_mail: '',
        receipt_phone: '',
        // edit
        receipt_edit_name: '',
        receipt_edit_mail: '',
        receipt_edit_phone: '',
        receiptradioGroup: '2',
        receipt_edit_home_address: '',
        receipt_edit_company_address: '',
        receipt_edit_company_name: '',
        // type 2
        receipt_company_address: '',
        receipt_company_name: '',
        // type 1
        receipt_home_address: '',
        // mix address
        receipt_mix_address: '',
      },
    ],
    receipt_company_show: true,
    receipt_home_show: false,
    receipt_edit_home_area_lists: '',
    receipt_edit_home_area_detail: '',
    receipt_home_area_lists: '',
    receipt_home_area_detail: '',
    // address area select
    area_lists: [],
    area_detail: {},
    // pay
    PayradioGroup: '1',
    // shop info
    shop_info: [],
    shop_info_total_price: 0,
    // shop remark
    remark: '',
    // get final send back data
    sendbluemoney: [
      {
        order_uuid: '',
        order_id: '',
        price: '',
        email: '',
        production: '',
      },
    ],
    // disable click
    cantsendclick: false,
  }),
  methods: {
    async GetLIneID() {
      // alert(window.location.href);
      const self = this;
      sessionStorage.setItem('line_accessToken', this.$route.query.user_id);
      sessionStorage.setItem('group_uuid', this.$route.query.group_uuid);
      self.user_line_id = sessionStorage.getItem('line_accessToken');
      self.group_uuid = sessionStorage.getItem('group_uuid');
      await this.CheckLineRegister();
      await this.GetShopInfo();
      await this.GetAreaInfo();
    },
    CheckLineRegister() {
      const self = this;
      Vue.axios({
        method: 'post',
        url: 'https://shopbkd.cheerlife.io/cheerlife/v1/recommend/check-user-register',
        data: {
          access_key: self.access_key,
          user_line_id: self.user_line_id,
        },
      })
        .then((response) => {
          // console.log(response);
          self.is_line_register = response.data.message;
          if (self.is_line_register === 'registered') {
            self.isnt_linechecked = false;
            self.is_linechecked = true;
            // show/hide choose address
            if (response.data.address != '' || response.data.address != null) {
              self.not_first_address = false;
              self.isnt_order_buy = false;
              self.is_order_buy = true;
            } else {
              self.not_first_address = true;
              self.isnt_order_buy = true;
              self.is_order_buy = false;
            }
            if (response.data.rec_address != '' || response.data.rec_address != null) {
              self.isnt_receipt_buy = false;
              self.is_receipt_buy = true;
            } else {
              self.isnt_receipt_buy = true;
              self.is_receipt_buy = false;
            }
            // order
            self.orderinfo[0].order_name = response.data.name;
            self.orderinfo[0].order_phone = response.data.mobile;
            self.orderinfo[0].order_mail = response.data.email;
            // order edit
            self.orderinfo[0].order_edit_name = response.data.name;
            self.orderinfo[0].order_edit_phone = response.data.mobile;
            self.orderinfo[0].order_edit_mail = response.data.email;
            self.order_edit_home_area_lists = response.data.city;
            self.order_edit_home_area_detail = response.data.area;
            self.orderinfo[0].order_edit_home_address = response.data.address;
            self.orderinfo[0].order_edit_company_address = response.data.company_address;
            self.orderinfo[0].order_edit_company_name = response.data.company_name;
            // order
            self.order_home_area_lists = response.data.city;
            self.order_home_area_detail = response.data.area;
            self.orderinfo[0].order_home_address = response.data.address;
            self.orderinfo[0].order_company_address = response.data.company_address;
            self.orderinfo[0].order_company_name = response.data.company_name;
            if (response.data.address_type === 1) {
              self.orderinfo[0].orderradioGroup = '1';
              self.order_company_show = false;
              self.order_home_show = true;
              self.orderinfo[0].order_mix_address = `${response.data.city}${response.data.area}${response.data.address}`;
            } else {
              self.orderinfo[0].orderradioGroup = '2';
              self.orderinfo[0].order_mix_address = `${response.data.company_address}(${response.data.company_name})`;
            }
            // receipt
            self.receiptinfo[0].receipt_name = response.data.rec_name;
            self.receiptinfo[0].receipt_phone = response.data.rec_mobile;
            self.receiptinfo[0].receipt_mail = response.data.rec_email;
            // receipt edit
            self.receiptinfo[0].receipt_edit_name = response.data.rec_name;
            self.receiptinfo[0].receipt_edit_phone = response.data.rec_mobile;
            self.receiptinfo[0].receipt_edit_mail = response.data.rec_email;
            self.receipt_edit_home_area_lists = response.data.rec_city;
            self.receipt_edit_home_area_detail = response.data.rec_area;
            self.receiptinfo[0].receipt_edit_home_address = response.data.rec_address;
            self.receiptinfo[0].receipt_edit_company_address = response.data.company_address;
            self.receiptinfo[0].receipt_edit_company_name = response.data.company_name;
            // receipt
            self.receipt_home_area_lists = response.data.rec_city;
            self.receipt_home_area_detail = response.data.rec_area;
            self.receiptinfo[0].receipt_company_address = response.data.company_address;
            self.receiptinfo[0].receipt_company_name = response.data.company_name;
            self.receiptinfo[0].receipt_home_address = response.data.rec_address;
            if (response.data.rec_address_type === 1) {
              self.receiptinfo[0].receiptradioGroup = '1';
              // checkbox same as order
              self.pre_rec_address_type = '1',
              self.receipt_company_show = false;
              self.receipt_home_show = true;
              self.receiptinfo[0].receipt_mix_address = `${response.data.rec_city}${response.data.rec_area}${response.data.rec_address}`;
            } else {
              self.receiptinfo[0].receiptradioGroup = '2';
              // checkbox same as order
              self.pre_rec_address_type = '2',
              self.receiptinfo[0].receipt_mix_address = `${response.data.company_address}(${response.data.company_name})`;
            }
          } else {
            self.isnt_linechecked = true;
            self.is_linechecked = false;
          }
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    },
    SendSMSCode() {
      const self = this;
      Vue.axios({
        method: 'post',
        url: 'https://shopbkd.cheerlife.io/cheerlife/v1/recommend/send-verify',
        data: {
          access_key: self.access_key,
          user_line_id: self.user_line_id,
          mobile: self.orderinfo[0].order_edit_phone,
        },
      })
        .then((response) => {
          alert(response.data.message);
          alert("驗證碼已發送");
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    },
    CheckSMSCode() {
      const self = this;
      Vue.axios({
        method: 'post',
        url: 'https://shopbkd.cheerlife.io/cheerlife/v1/recommend/check-verify',
        data: {
          access_key: self.access_key,
          user_line_id: self.user_line_id,
          mobile: self.orderinfo[0].order_edit_phone,
          code: self.inputsms,
        },
      })
        .then((response) => {
          alert(response.data.message);
          self.is_linechecked = true;
        })
        .catch((error) => {
          alert(error.response.data.error);
        });
    },
    CheckOrderAddress() {
      const self = this;
      self.orderinfo[0].order_name = self.orderinfo[0].order_edit_name;
      self.orderinfo[0].order_phone = self.orderinfo[0].order_edit_phone;
      self.orderinfo[0].order_mail = self.orderinfo[0].order_edit_mail;
      self.order_home_area_lists = self.order_edit_home_area_lists;
      self.order_home_area_detail = self.order_edit_home_area_detail;
      self.orderinfo[0].order_home_address = self.orderinfo[0].order_edit_home_address;
      self.orderinfo[0].order_company_address = self.orderinfo[0].order_edit_company_address;
      self.orderinfo[0].order_company_name = self.orderinfo[0].order_edit_company_name;
      if(self.orderinfo[0].orderradioGroup === '1') {
        self.orderinfo[0].order_mix_address = `${self.order_home_area_lists}${self.order_home_area_detail}${self.orderinfo[0].order_home_address}`;
      } else {
        self.orderinfo[0].order_mix_address = `${self.orderinfo[0].order_company_address}(${self.orderinfo[0].order_company_name})`;
      }
      self.isnt_order_buy = false;
      self.is_order_buy = true;
      self.orderinfo[0].order_dialog = false;
    },
    // same as order address info checkbox click
    SameOrderData(event) {
      const self = this;
      if (event === true) {
        self.receiptinfo[0].receipt_name = self.orderinfo[0].order_name;
        self.receiptinfo[0].receipt_phone = self.orderinfo[0].order_phone;
        self.receiptinfo[0].receipt_mail = self.orderinfo[0].order_mail;
        self.receiptinfo[0].receipt_mix_address = self.orderinfo[0].order_mix_address;
        // checkbox as order
        self.receiptinfo[0].receiptradioGroup = self.orderinfo[0].orderradioGroup;
        if (self.receiptinfo[0].receiptradioGroup === '1') {
          self.receipt_company_show = false;
          self.receipt_home_show = true;
        } else {
          self.receipt_company_show = true;
          self.receipt_home_show = false;
        }
        self.receipt_home_area_lists = self.order_home_area_lists;
        self.receipt_home_area_detail = self.order_home_area_detail;
        self.receiptinfo[0].receipt_home_address = self.orderinfo[0].order_home_address;
        self.receiptinfo[0].receipt_company_address = self.orderinfo[0].order_company_address;
        self.receiptinfo[0].receipt_company_name = self.orderinfo[0].order_company_name;
      } else {
        self.receiptinfo[0].receipt_name = '';
        self.receiptinfo[0].receipt_phone = '';
        self.receiptinfo[0].receipt_mail = '';
        self.receiptinfo[0].receipt_mix_address = '';
        // checkbox as order cancel
        self.receiptinfo[0].receiptradioGroup = self.pre_rec_address_type;
        if (self.receiptinfo[0].receiptradioGroup === '1') {
          self.receipt_company_show = false;
          self.receipt_home_show = true;
        } else {
          self.receipt_company_show = true;
          self.receipt_home_show = false;
        }
        self.receipt_home_area_lists = '';
        self.receipt_home_area_detail = '';
        self.receiptinfo[0].receipt_home_address = '';
        self.receiptinfo[0].receipt_company_address = '';
        self.receiptinfo[0].receipt_company_name = '';
      }
    },
    CheckReceiptAddress() {
      const self = this;
      self.receiptinfo[0].receipt_name = self.receiptinfo[0].receipt_edit_name;
      self.receiptinfo[0].receipt_phone = self.receiptinfo[0].receipt_edit_phone;
      self.receiptinfo[0].receipt_mail = self.receiptinfo[0].receipt_edit_mail;
      self.receipt_home_area_lists = self.receipt_edit_home_area_lists;
      self.receipt_home_area_detail = self.receipt_edit_home_area_detail;
      self.receiptinfo[0].receipt_home_address = self.receiptinfo[0].receipt_edit_home_address;
      self.receiptinfo[0].receipt_company_address = self.receiptinfo[0].receipt_edit_company_address;
      self.receiptinfo[0].receipt_company_name = self.receiptinfo[0].receipt_edit_company_name;
      if(self.receiptinfo[0].receiptradioGroup === '1') {
        self.receiptinfo[0].receipt_mix_address = `${self.receipt_home_area_lists}${self.receipt_home_area_detail}${self.receiptinfo[0].receipt_home_address}`;
      } else {
        self.receiptinfo[0].receipt_mix_address = `${self.receiptinfo[0].receipt_company_address}(${self.receiptinfo[0].receipt_company_name})`;
      }
      self.isnt_receipt_buy = false;
      self.is_receipt_buy = true;
      self.receiptinfo[0].receipt_dialog = false
    },
    onOrderAreaChange() {
      this.order_edit_home_area_detail = '';
    },
    onRecriptAreaChange() {
      this.receipt_edit_home_area_detail = '';
    },
    GetAreaInfo() {
      const self = this;
      Vue.axios({
        method: 'post',
        url: 'https://shopbkd.cheerlife.io/cheerlife/v1/recommend/city-area',
        data: {
          access_key: self.access_key,
        },
      })
        .then((response) => {
          self.area_lists = response.data.area_lists;
          self.area_detail = response.data.area_detail;
        })
        .catch((error) => {
          alert('取得地址失敗');
          alert(error.response);
        });
    },
    GetShopInfo() {
      const self = this;
      Vue.axios({
        method: 'post',
        url: 'https://shopbkd.cheerlife.io/12team/v1/groups/direct_groupbuy_info',
        data: {
          access_key: self.access_key,
          group_uuid: self.group_uuid,
        },
      })
        .then((response) => {
          // console.log(response);
          const self = this;
          self.shop_info = response.data;
          self.shop_info_total_price = response.data.special_price + response.data.shipping_fee;
          self.product_id = response.data.product_id;
        })
        .catch((error) => {
          alert('取得商品失敗');
          alert(error.response.data.message);
        });
    },
    onOrderChange(event) {
      const self = this;
      if (event === "1") {
        self.order_company_show = false;
        self.order_home_show = true;
      } else {
        self.order_company_show = true;
        self.order_home_show = false;
      }
    },
    onReceiptChange(event) {
      const self = this;
      if (event === "1") {
        self.receipt_company_show = false;
        self.receipt_home_show = true;
      } else {
        self.receipt_company_show = true;
        self.receipt_home_show = false;
      }
    },
    async CheckOrderData() {
      const result = confirm("您確定要送出訂單嗎？");
      if (result == false) {
        return false;
      } else {
        const self = this;
        if (self.orderinfo[0].orderradioGroup == '2') {
          // 收件人選公司地址
          if (self.orderinfo[0].order_company_address == '' || self.orderinfo[0].order_company_address == undefined) {
            alert('未填寫寄件人公司地址');
            return false;
          } else if (self.orderinfo[0].order_company_name == '' || self.orderinfo[0].order_company_name == undefined) {
            alert('未填寫寄件人公司地址');
            return false;
          }
        } else if (self.orderinfo[0].orderradioGroup == '1') {
          // 收件人選其他地址
          if (self.order_home_area_lists == '' || self.order_home_area_lists == undefined) {
            alert('未選取訂購人城市/地區');
            return false;
          } else if (self.order_home_area_detail == '' || self.order_home_area_detail == undefined) {
            alert('未填寫訂購人區/縣');
            return false;
          } else if (self.orderinfo[0].order_home_address == '' || self.orderinfo[0].order_home_address == undefined) {
            alert('未填寫訂購人地址');
            return false;
          }
        }
        if (self.receiptinfo[0].receiptradioGroup == '2') {
          // 收貨人選公司地址
          if (self.receiptinfo[0].receipt_company_address == '' || self.receiptinfo[0].receipt_company_address == undefined) {
            alert('未填寫收貨人公司地址');
            return false;
          } else if (self.receiptinfo[0].receipt_company_name == '' || self.receiptinfo[0].receipt_company_name == undefined) {
            alert('未填寫收貨人公司地址');
            return false;
          }
        } else if (self.receiptinfo[0].receiptradioGroup == '1') {
          // 收貨人選其他地址
          if (self.receipt_home_area_lists == '' || self.receipt_home_area_lists == undefined) {
            alert('未選取收貨人城市/地區');
            return false;
          } else if (self.receipt_home_area_detail == '' || self.receipt_home_area_detail == undefined) {
            alert('未填寫收貨人區/縣');
            return false;
          } else if (self.receiptinfo[0].receipt_home_address == '' || self.receiptinfo[0].receipt_home_address == undefined) {
            alert('未填寫收貨人地址');
            return false;
          }
        }
        if (self.access_key == '' || self.access_key == undefined || self.user_line_id == '' || self.user_line_id == undefined || self.product_id == '' || self.product_id == undefined || self.group_uuid == '' || self.group_uuid == undefined) {
          alert('資訊不完整');
          return false;
        } else if (self.orderinfo[0].order_name == '' || self.orderinfo[0].order_name == undefined) {
          alert('未填寫訂購人姓名');
          return false;
        } else if (self.orderinfo[0].order_phone == '' || self.orderinfo[0].order_phone == undefined) {
          alert('未填寫訂購人電話');
          return false;
        } else if (self.orderinfo[0].order_mail == '' || self.orderinfo[0].order_mail == undefined) {
          alert('未填寫訂購人信箱');
          return false;
        } else if (self.receiptinfo[0].receipt_name == '' || self.receiptinfo[0].receipt_name == undefined) {
          alert('未填寫收貨人姓名');
          return false;
        } else if (self.receiptinfo[0].receipt_phone == '' || self.receiptinfo[0].receipt_phone == undefined) {
          alert('未填寫收貨人手機');
          return false;
        } else if (self.receiptinfo[0].receipt_mail == '' || self.receiptinfo[0].receipt_mail == undefined) {
          alert('未填寫收貨人信箱');
          return false;
        } else {
          try {
            self.cantsendclick = true;
            let response = await this.SendAxiosFinalDatas();
            // wait res back
              self.sendbluemoney[0].order_uuid = response.data.order_uuid;
              self.sendbluemoney[0].order_id = response.data.order_id;
              self.sendbluemoney[0].price = parseInt(response.data.price);
              self.sendbluemoney[0].email = response.data.email;
              self.sendbluemoney[0].production = response.data.production;
              await this.SendFinalData();
            } catch (error) {
              self.cantsendclick = false;
              alert(error.response.data.message);
              return false;
            }
        }
      }
    },
    // await
    SendAxiosFinalDatas() {
      return new Promise((resolve, reject) => {
        const self = this;
        Vue.axios({
            method: 'post',
            url: 'https://shopbkd.cheerlife.io/cheerlife/v1/recommend/add-order',
            data: {
              access_key: self.access_key,
              user_line_id: self.user_line_id,
              product_id: parseInt(self.product_id),
              group_uuid: self.group_uuid,
              qty: 1,
              deliver_type_id: 1,
              shipping_fee: self.shipping_fee,
              // 寄件人
              user_order_name: self.orderinfo[0].order_name,
              user_order_mobile: self.orderinfo[0].order_phone,
              user_order_email: self.orderinfo[0].order_mail,
              // 個人地址 || 公司地址
              order_address_type: parseInt(self.orderinfo[0].orderradioGroup),
              user_order_city: self.order_home_area_lists,
              user_order_area: self.order_home_area_detail,
              user_order_address: self.orderinfo[0].order_home_address,
              company_address: self.orderinfo[0].order_company_address,
              company_name: self.orderinfo[0].order_company_name,
              // 收貨人
              user_rec_name: self.receiptinfo[0].receipt_name,
              user_rec_mobile: self.receiptinfo[0].receipt_phone,
              user_rec_email: self.receiptinfo[0].receipt_mail,
              rec_address_type: parseInt(self.receiptinfo[0].receiptradioGroup),
              user_rec_city: self.receipt_home_area_lists,
              user_rec_area: self.receipt_home_area_detail,
              user_rec_address: self.receiptinfo[0].receipt_home_address,
              rec_company_address: self.receiptinfo[0].receipt_company_address,
              rec_company_name: self.receiptinfo[0].receipt_company_name,
              // 發票
              receipt_send_type: 1,
              receipt_company_name: "",
              receipt_company_id: "",
              remark: self.remark,
              // 信用卡付款
              pay_type: 1,
              // 貨到付款
              service_fee: 0,
            },
          })
            .then((response) => {
              resolve(response);
              self.sendbluemoney[0].order_uuid = response.data.order_uuid;
              self.sendbluemoney[0].order_id = response.data.order_id;
              self.sendbluemoney[0].price = parseInt(response.data.price);
              self.sendbluemoney[0].email = response.data.email;
              self.sendbluemoney[0].production = response.data.production;
            })
            .catch((error) => {
              reject(error);
            });
        })
    },
    SendtoBlueMoney() {
        document.getElementById('bluemoneyForm').submit();
    },
    async SendFinalData() {
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      await sleep(2000);
      this.SendtoBlueMoney();
    },
  },
  mounted() {
    this.GetLIneID();
  },
  watch: {
  },
};
</script>
<style scoped lang="sass">
  select
    -webkit-appearance: none
    -moz-appearance: none
    -ms-appearance: none
    appearance: none
    outline: 0
    box-shadow: none
    border: 0 !important
    background: #2c3e50
    background-image: none
  select::-ms-expand
    display: none
  .select_sty
    position: relative
    display: flex
    width: 20em
    height: 3em
    line-height: 3
    background: #2c3e50
    overflow: hidden
    border-radius: .25em
  select
    flex: 1
    padding: 0 .5em
    color: #fff
    cursor: pointer
  .select_sty::after
    content: '\25BC'
    position: absolute
    top: 0
    right: 0
    padding: 0 1em
    background: #34495e
    color: #ffffff
    cursor: pointer
    pointer-events: none
    -webkit-transition: .25s all ease
    -o-transition: .25s all ease
    transition: .25s all ease
  .select_sty:hover::after
    color: #f39c12
</style>>
